import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import DialogActions from "@mostrans/web-components/components/base/Dialog/DialogActions";
import {
    Dialog,
    Zoom,
    useMediaQuery,
    useTheme
} from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { useGetdetailOpportunity } from "../../GQL/Opportunity/hooks/useGetdetailOpportunity";
import { addCandidateToOpportunity } from "../../graphql/mutations";
import {
    getCandidateByID,
    getOpportunitiesByCandidateID,
    getOpportunityByID,
    getOpportunityIsActive,
} from "../../graphql/query";
import { getOpportunityByCandidateID } from "../../shared/atom/detailCandidate";
import {
    isLoggedInSelector,
    userDataSelector,
} from "../../shared/globalStates";
import { toastError, toastSuccess } from "../../shared/helpers";
import { useModals } from "../../shared/hooks/useModals";
import { useValidateUser } from "../../shared/hooks/useValidateUser";
import ModalContentDetailOpportunity from "./ModalContentDetailOpportunity";

function ModalDetailOpportunity({
    id,
    open,
    setOpen,
    handleClose,
    opportunityId,
    setdata,
}) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const [detailOpportunity] = useGetdetailOpportunity(opportunityId);
    const history = useHistory();
    const validate = useValidateUser();
    const client = useApolloClient();
    const { closeModal } = useModals()
    const isLoggedIn = useRecoilValue(isLoggedInSelector);
    const userData = useRecoilValue(userDataSelector);
    const [isAuth, setIsAuth] = useState(false);
    const [loading, setLoading] = useState(true);
    const [dataCandidate, setDataCandidate] = useState();
    const [listApply, setListApply] = useRecoilState(
        getOpportunityByCandidateID
    );
    const [data, setData] = useState([]);

    useEffect(() => {
        getCandidateByID(client).then(setDataCandidate);
    }, []);



    useEffect(() => {
        getOpportunityByID(client, opportunityId).then(setData);

        if (isAuth) {
            if (isEmpty(listApply)) {
                getOpportunitiesByCandidateID(client).then(setListApply);
            }
        }
        validate.then(setIsAuth);
    }, [listApply]);

    useEffect(() => {
        if (!isEmpty(data)) {
            setLoading(false);
        }
    }, [data]);

    const onApplyJob = async () => {
        if (isAuth === true) {
            if (
                !dataCandidate?.curr_benefits &&
                dataCandidate?.curr_salary === 0
            ) {
                return toastError(
                    "Current Salary and benefit information is required"
                );
            }
            if (
                !dataCandidate?.expected_benefits &&
                dataCandidate?.expected_salary === 0
            ) {
                history.push("/career/home");
                return toastError(
                    "Expected Salary and benefit information is required"
                );
            }
            if (listApply.find((e) => e.id === data.id)) {
                toastError("Error, you have already applied for this job");
                setOpen(false);
            } else {
                const add = await addCandidateToOpportunity(client, data.id);
                if (add.status !== "000") {
                    toastError("Error, try again later");
                    setOpen(false);
                } else {
                    toastSuccess("Success, Apply job successfully");
                    if (isLoggedIn) {
                        const refetch = await getOpportunityIsActive(
                            client,
                            parseInt(userData.id)
                        );
                        setdata(refetch);
                    }
                    setOpen(false);
                }
            }
        } else {
            handleClose()
            history.push({
                pathname: `/application-form`,
                state: { id: data.id },
            });
        }
    };

    // const onApplyJob = async () => {
    //     if (opportunityId) {
    //         handleClose()
    //         history.push({ pathname: `/application-form`, state: { id: opportunityId } });
    //     } else {
    //         toast.error("An error occurred, please reload the page.")
    //     }
    // }

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            maxWidth="md"
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-card-details"
            closeAfterTransition>
            <Zoom in={open} style={{ transitionDelay: open ? "50ms" : "0ms" }}>
                <div>
                    <ModalContentDetailOpportunity
                        detailOpportunity={detailOpportunity?.data}
                    />
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                            variant="outlined"
                            color="error">
                            Close
                        </Button>
                        <Button onClick={onApplyJob} variant="contained">
                            Apply Now
                        </Button>
                    </DialogActions>
                </div>
            </Zoom>
        </Dialog>
    );
}

export default ModalDetailOpportunity;
